import createLucideIcon from '../createLucideIcon';

const Navigation2 = createLucideIcon('Navigation2Icon', [
  ['polygon', { points: '12 2 19 21 12 17 5 21 12 2', key: 'x8c0qg' }],
]);

export default Navigation2;
